<template>
    <div v-if="article" class="r-column fr br5 bgw mht-400">
        <Crumb :typeId="article.category_id"></Crumb>
        <div v-if="!article.title" class="tcenter tc9 fs18 no-cont">
            <div :class="isLoad ? 'icon-jiazaizhong' : 'icon-kongneirong'" 
                class="iconfont"></div>
            {{isLoad ? '稍等，数据加载中' : '抱歉，没有相关内容'}}
        </div>
        <div class="notice-detail">
            <div class="notice-title fs30 fbold tcenter pb40">
                {{ article.title }}
            </div>
            <div class="notice-cont ncont fs16 lh20" v-html="article.content">
            </div>
        </div>
        <div v-if="articleDownload.length">
            <div class="fs15 mb5">附件下载</div>
            <div v-for="item in articleDownload" 
                :key="item.nm" 
                @click="downloadFile(item)" 
                style="margin-bottom: 5px;padding: 0 20px;color: blue;" 
                class="cpointer">
                {{ item.nm }}
            </div>
        </div>
        
    </div>
   
</template>
<script>
import Crumb from '@/components/common/Crumb'
import { throws } from 'assert'
export default {
    data() {
        return {
            article: [],
            typeId: 0,
            isLoad: false,
            articleDownload: []
        }
    },
    components: {
        Crumb
    },
    created() {
        this.initData()
    },
    methods: {
        initData() {
            this.typeId = this.$route.params.id
            this.getNewsList()
        },
        getNewsList() {
            this.isLoad = true
            const query = {
                category_id: this.typeId,
            }
            this.$request.get('article/list', query, res => {
                if (res.data.code == 200) {
                    const data = res.data.data
                    let article = data.data[0]
                    article.category_id = article.category_id.toString()
                    var fileArr = []
                    if (article.article_file) {
                        for (var i in article.article_file) {
                            var file = article.article_file[i]
                            var arr = file.split('/')
                            var nm = arr[arr.length - 1].split('.')[0]
                            fileArr[i] = { nm, url: file }
                        }
                    }
                    this.articleDownload = fileArr
                    this.article = article
                    this.isLoad = false
                }
            }, err => {
                console.log(err)
                this.isLoad = false
            })
        },
        chagePage(page) {
            this.page = page - 1
            this.getNewsList()
        },
        downloadFile(item) {
            // const blob = new Blob([item.url], { type: 'application/pdf' })
            // var el = document.createElement('a')
            // el.download = item.nm
            // el.style.display = 'none'
            // const href = window.URL.createObjectURL(blob)
            // el.href = href
            // document.body.appendChild(el)
            // el.click()
            // document.body.removeChild(el)
            // URL.revokeObjectURL(el.href)
            const link = document.createElement("a"); //自己创建的a标签
            link.href = item.url
            link.download = item.nm
            link.target = "_blank"
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        }

    }
}
</script>
<style scope>
</style>
    